import { render, staticRenderFns } from "./Cars.vue?vue&type=template&id=5d984478&scoped=true"
import script from "./Cars.vue?vue&type=script&lang=js"
export * from "./Cars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d984478",
  null
  
)

export default component.exports